/** Module names for which the side menu is opened by default. */
const SIDE_MENU_OPENED_BY_DEFAULT = ['certify2'];

/**
 * Determines if the side menu should be opened by default based on the current URL.
 * @param url - The current URL string (e.g. '/certify2/dashboard')
 */
export function getSideMenuOpenedByDefault(url: string): boolean {
  const [module] = url.split('/').filter((segment) => !!segment);
  return SIDE_MENU_OPENED_BY_DEFAULT.includes(module);
}

/**
 * Detects if the current device is a mobile/tablet device by user-agent.
 */
export function isMobile(): boolean {
  return !!(
    navigator.userAgent.match(/Android/i) ||
    navigator.userAgent.match(/webOS/i) ||
    navigator.userAgent.match(/iPhone/i) ||
    navigator.userAgent.match(/iPad/i) ||
    navigator.userAgent.match(/iPod/i) ||
    navigator.userAgent.match(/BlackBerry/i) ||
    navigator.userAgent.match(/Windows Phone/i)
  );
}
